import { render, staticRenderFns } from "./Ebook.vue?vue&type=template&id=d4cecd54&scoped=true&"
import script from "./Ebook.vue?vue&type=script&lang=js&"
export * from "./Ebook.vue?vue&type=script&lang=js&"
import style0 from "./Ebook.vue?vue&type=style&index=0&id=d4cecd54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cecd54",
  null
  
)

export default component.exports